import * as angular from 'angular';
import 'angular-xeditable';
import ContractSettingsController from './contract-settings-controllers';
import server from '../../../integration/server/server-services';

export default angular.module('dataforvalter.contract-settings', [
    'dataforvalter.security',
    'ui.bootstrap',
    'xeditable',
    'ngMessages'
]).run(editable)
    .controller('ContractSettingsController', ContractSettingsController)
    .directive('uniqueNewName', uniqueNewName)
    .directive('excelFileModel', function(): any {
        return {
            restrict: 'A',
            link(scope: any, element: JQLite, attrs: {excelFileModel: string}) {
                const fileModel = scope[attrs.excelFileModel];

                element.bind('change', function() {
                    scope.$apply(function() {
                        const e = element[0] as any;
                        angular.forEach(e.files, function(file) {
                            fileModel(file);
                        });
                        e.value = '';
                    });
                });
            }
        };
    })
    .name;

function uniqueNewName($q: angular.IQService, server: server) {
    return {
        require: 'ngModel',
        link(scope: any, elem: JQLite, attr: angular.IAttributes, ctrl: angular.INgModelController) {
            ctrl.$asyncValidators.uniqueNewName = function(value) {

                const defer = $q.defer();

                // validators are triggered once the value is resolved, so when first loading the contract
                // the validator is run before we have had the chance to set conCtrl.originalContractName.
                // So we assume originalContractName == undefined means OK.
                const originalContractName = scope.conCtrl.originalContractName;
                if (!originalContractName || value === originalContractName) {
                    defer.resolve();
                } else {
                    server.countContractsWithName(value).then(function(count) {
                        if (count === 0) {
                            defer.resolve();
                        } else {
                            defer.reject();
                        }
                    });
                }

                return defer.promise;
            };
        }
    };
}
uniqueNewName.$inject = ['$q', 'server'];

function editable(editableOptions: any) {
    editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs2', 'default'
}
editable.$inject = ['editableOptions'];
